<template>
  <div class="my-activity">
    <div class="inner-wrapper" v-if="recurringDonationList.list.length > 0 || myActivityList.list.length > 0 && !loading">
      <h1 :style="{ textAlign: 'center' }" v-translate>My Activity</h1>
      <div class="activity-container" v-for="(activity, i) in myActivityList.list" :key="i">
        <ActivityCard :activity="activity" />
      </div>
      <div
        class="activity-container"
        v-for="donation in recurringDonationList.list"
        :key="donation.id"
      >
        <DonationCard :donation="donation" />
      </div>
      <LoadSpinner v-if="myActivityList.loadingNextPage" />

      <div class="pagination-container">
        <button
          v-if="myActivityList.pagination.hasPrevPage"
          class="button"
          @click="() => myActivityList.prevPage()"
          :disabled="!myActivityList.pagination.hasPrevPage"
        >
          <font-awesome-icon
            class="pagination-icons"
            :icon="['fa', 'chevron-left']"
            :style="{ fontSize: '25px', color: 'white' }"
          ></font-awesome-icon>
        </button>

        <button
          v-if="myActivityList.pagination.hasNextPage"
          class="button"
          @click="() => myActivityList.nextPage()"
          :disabled="!myActivityList.pagination.hasNextPage"
        >
          <font-awesome-icon
            class="pagination-icons"
            :icon="['fa', 'chevron-right']"
            :style="{ fontSize: '25px' }"
          ></font-awesome-icon>
        </button>
      </div>
    </div>

    <!-- No Activity History -->
    <div v-if="recurringDonationList.list.length == 0 && myActivityList.list.length == 0 && !loading" class="no-activity">
      <h3 :style="{ alignSelf: 'center' }" v-translate>No Activity History Available</h3>
    </div>

    <LoadSpinner v-if="loading" />
  </div>
</template>

<script>
import Action from '../services/actions'
import Donation from '@/services/donations'
import CollectionManager from '../services/collectionManager'

import DonationCard from '@/components/myActivity/DonationCard'
import ActivityCard from '@/components/myActivity/ActivityCard'
import LoadSpinner from '@/components/LoadSpinner'

export default {
  name: 'MyActivity',
  components: {
    ActivityCard,
    LoadSpinner,
    DonationCard,
  },
  data() {
    return {
      myActivityList: CollectionManager.create({
        ModelClass: Action,
        filters: { ordering: '-datetime_created', actionType: 'DONATION' },
      }),
      recurringDonationList: CollectionManager.create({
        ModelClass: Donation,
        filters: { frequency: 'RECURRING', uniqueSubscription: true },
      }),
      loading: true,
    }
  },
  async created() {
    await this.refresh()
    this.loading = false
  },
  methods: {
    async refresh() {
      await this.myActivityList.refresh()
      await this.recurringDonationList.refresh()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';

.my-activity {
  @include screen-container();
  justify-content: flex-start;
  padding: 2rem 2rem 3rem 2rem;
}
.inner-wrapper {
  width: 100%;
}
.activity-container {
  width: 100%;
}
.pagination-container {
  margin-top: 10px;
  display: flex;
  width: 100%;
  justify-content: space-evenly;
}
button {
  border: none;
  background: $white;
  height: 50px;
  width: 50px;
  border-radius: 100%;
  background: var(--dark-brand-color);
}
.pagination-icons {
  color: $white;
}
.no-activity {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 500px;
}
</style>
